export const JRL_REGISTRATION_STATUS = {
  CLUB_REQUIRED: 'CLUB_REQUIRED',
  CODE_REQUIRED: 'CODE_REQUIRED',
  PUBLIC: 'PUBLIC',
}

export const JRL_REGISTRATION_STATUS_LABELS = {
  [JRL_REGISTRATION_STATUS.PUBLIC]: 'Open to the Public',
  [JRL_REGISTRATION_STATUS.CODE_REQUIRED]:
    'Open to the Public with Restrictions',
  [JRL_REGISTRATION_STATUS.CLUB_REQUIRED]: 'Club Membership Required',
}

export const JRL_REGISTRATION_WITH_CODE = {
  [JRL_REGISTRATION_STATUS.PUBLIC]: false,
  [JRL_REGISTRATION_STATUS.CODE_REQUIRED]: true,
  [JRL_REGISTRATION_STATUS.CLUB_REQUIRED]: true,
}

export const JRL_LOCAL_LEAGUE_TYPE = {
  IN_HOUSE: 'IN_HOUSE',
  MULTI_FACILITY: 'MULTI_FACILITY',
  MIXED: 'MIXED',
  UNDECIDED: 'UNDECIDED',
}

export const JRL_LOCAL_LEAGUE_TYPE_LABELS = {
  [JRL_LOCAL_LEAGUE_TYPE.IN_HOUSE]:
    "All of my Teams will participate in an 'In-House' League",
  [JRL_LOCAL_LEAGUE_TYPE.MULTI_FACILITY]:
    "All of my Teams will participate in a 'Multi-Facility' League",
  [JRL_LOCAL_LEAGUE_TYPE.MIXED]:
    "Mix of 'In-House' and 'Multi-Facility' Leagues",
  [JRL_LOCAL_LEAGUE_TYPE.UNDECIDED]: 'Undecided',
}
